<template>
  <div>
    <div
      class="modal fade"
      id="asignarCarrito"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Asignar Carrito</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true"> ×</span>
            </button>
          </div>
          <form @submit="asignarCarritoATarea">
            <div class="modal-body">
              <div class="form-group">
                <label for=""> Carrito</label>
                <input
                  id="barra_carrito"
                  class="form-control text-center"
                  placeholder="Carrito"
                  v-model="barra_carrito"
                  required
                  type="text"
                />
                <small v-if="error_carrito" class="form-text text-danger">
                  {{ error_carrito }}
                </small>
              </div>
              <button class="btn btn-lg btn-block btn-primary" type="submit">
                Aceptar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {},
  props: {
    id_tarea: {
      type: String,
    },
  },
  data() {
    return {
      barra_carrito: "",
      error_carrito: null,
    };
  },
  mounted() {
    $("#asignarCarrito").on("shown.bs.modal", function () {
      $("#barra_carrito").trigger("focus"); 
    });
  },
  methods: {
    asignarCarritoATarea(e) {
      e.preventDefault();
      let self = this;
      DynamicService.postAction(
        "wms",
        "tareas",
        self.id_tarea,
        "asignar_carrito",
        {
          barra: self.barra_carrito,
        }
      )
        .then((res) => {
          $("#asignarCarrito").modal("hide");
          self.$emit("asignado_carrito", self.id_tarea);
        })
        .catch((err) => {
          if (err.response.data.detail) {
            self.error_carrito = err.response.data.detail;
          }
        });
    },
  },
};
</script>
